/**
 * Created by Mark on 18/04/2017.
 */

import SelectContent from './select-content.js';
import AboutHomework  from './about-assignments.js';
import AssignAssignments from './assign-assignments.js';
import Save from './save-assignment.js';
import SelectType from './homework-type.js';
import SelectLanguage from './homework-language.js';
import VocabularyContent from './vocabulary-builder/vocabulary-content.js';
import CustomContent from './vocabulary-builder/custom-content.js';
import VocabularySettings from './vocabulary-builder/vocabulary-settings.js';
import VerbBuilder from './verb-builder/verb-builder.js';
export default [ SelectLanguage , SelectType ,  AssignAssignments , Save];



// WEBPACK FOOTER //
// ./src/components/wizard/homework-steps/index.js